export default __webpack_public_path__ + "static/media/card-big.6361f9af.png";